<template>
  <div class="echartsbox">
    <vannav></vannav>
    <div id="ect"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      option: {
        grid: {
          top: "20%",
          bottom: "15%",
          right: "7%",
          left: "12%"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        legend: {
          show: true,
          data: ["用能趋势"],
          icon: "circle"
        },
        yAxis: {
          type: "value",
          name: "(单位KWh)"
        },
        series: [
          {
            name: "用能趋势",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "bar",
            smooth: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)"
            },
            itemStyle: {
              normal: {
                color: "#2b94fe",
                lineStyle: {
                  color: "#2b94fe"
                }
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.safelyEchart();
  },
  methods: {
    safelyEchart() {
      var myChart = this.$echarts.init(document.getElementById("ect"));
      // myChart.clear()
      myChart.setOption(this.option);
      window.onresize = function() {
        myChart.resize();
      };
    }
  }
};
</script>

<style scoped lang="less">
.echartsbox {
  width: 100%;
  height: 200px;
  & > div {
    width: 100%;
    height: 100%;
  }
}
</style>
